import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import type {AgentTypeId} from '../../../types'
import {isPipelinesAgentPageEnabled} from '../../../utils/featureToggles'
import {preloadAgentTypePage} from '../../pages/AgentsPages/AgentTypePage/AgentTypePage.preload'

export const preloadAppAgentType =
  (agentTypeId: AgentTypeId): AppThunk<LoadedEndpoints> =>
  dispatch => {
    if (isPipelinesAgentPageEnabled()) {
      return []
    }
    return dispatch(preloadAgentTypePage(agentTypeId))
  }
